<template>
  <div class="transfer">
    <a href="https://www.tokenpocket.pro/?from=scatter-demo-eosjs2"></a>
    <img alt="TokenPocket logo" style="height:30px;" src="../assets/ic_launcher_round.png">
    <h1>ZNL智能支付</h1>
    <TransferPayment/>
  </div>
</template>

<script>
// @ is an alias to /src
import TransferPayment from "@/components/TransferPayment.vue";

export default {
  name: "transfer",
  components: {
    TransferPayment
  }
};
</script>
